import React, { useState } from 'react';
import './Settings.css';

function Toggle({ on, onChange }) {
  return (
    <button className={`toggle${on ? ' on' : ''}`} onClick={() => onChange(!on)}>
      <span className="toggle-knob" />
    </button>
  );
}

export default function Settings() {
  const [notifs, setNotifs] = useState({ testCompletion: true, topScore: true, weeklyDigest: true, messages: false, productUpdates: false });
  const [prefs, setPrefs] = useState({ autoRank: true, showScores: true, blindMode: false });

  return (
    <div className="page settings">
      <div className="page-header">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-sub">Company profile, notifications, and platform preferences</p>
        </div>
      </div>

      <div className="settings-grid">
        {/* Company Profile */}
        <div className="settings-col">
          <div className="card settings-card">
            <div className="settings-section-title">Company Profile</div>
            <div className="form-group">
              <label>Company Name</label>
              <input type="text" defaultValue="Acme Technology Inc." />
            </div>
            <div className="form-group">
              <label>Industry</label>
              <input type="text" defaultValue="Software & Technology" />
            </div>
            <div className="form-group">
              <label>Company Size</label>
              <select defaultValue="50-200">
                <option>1–10 employees</option>
                <option>10–50 employees</option>
                <option value="50-200">50–200 employees</option>
                <option>200+ employees</option>
              </select>
            </div>
            <div className="form-group">
              <label>Website</label>
              <input type="text" defaultValue="https://acmetech.io" />
            </div>
          </div>

          <div className="card settings-card" style={{ marginTop: 16 }}>
            <div className="settings-section-title">Plan & Billing</div>
            <div className="billing-row">
              <div>
                <div className="plan-name">Pro Plan</div>
                <div className="plan-sub">500 candidates / month</div>
              </div>
              <div className="plan-price">$299<span>/mo</span></div>
            </div>
            <button className="btn-outline" style={{ width: '100%', marginTop: 12, fontSize: 12 }}>
              Upgrade to Enterprise
            </button>
          </div>
        </div>

        {/* Right column */}
        <div className="settings-col">
          <div className="card settings-card">
            <div className="settings-section-title">Notifications</div>
            {[
              { key: 'testCompletion', label: 'New Test Completion', sub: 'When a candidate finishes an assessment' },
              { key: 'topScore', label: 'Top Score Alerts', sub: 'Notify when score exceeds 90' },
              { key: 'weeklyDigest', label: 'Weekly Digest', sub: 'Pipeline summary every Monday' },
              { key: 'messages', label: 'Message Notifications', sub: 'When candidates send a message' },
              { key: 'productUpdates', label: 'Product Updates', sub: 'Feature releases and announcements' },
            ].map(item => (
              <div key={item.key} className="setting-row">
                <div>
                  <div className="setting-label">{item.label}</div>
                  <div className="setting-sub">{item.sub}</div>
                </div>
                <Toggle on={notifs[item.key]} onChange={v => setNotifs(p => ({ ...p, [item.key]: v }))} />
              </div>
            ))}
          </div>

          <div className="card settings-card" style={{ marginTop: 16 }}>
            <div className="settings-section-title">Test Preferences</div>
            {[
              { key: 'autoRank', label: 'Auto-rank candidates', sub: 'Sort automatically by score' },
              { key: 'showScores', label: 'Show scores to candidates', sub: 'Candidates can see their result' },
              { key: 'blindMode', label: 'Blind screening mode', sub: 'Hide names during initial review' },
            ].map(item => (
              <div key={item.key} className="setting-row">
                <div>
                  <div className="setting-label">{item.label}</div>
                  <div className="setting-sub">{item.sub}</div>
                </div>
                <Toggle on={prefs[item.key]} onChange={v => setPrefs(p => ({ ...p, [item.key]: v }))} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="settings-actions">
        <button className="btn-outline">Reset</button>
        <button className="btn-primary">Save Changes</button>
      </div>
    </div>
  );
}